import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import './TeacherProfile.css'
import './TeacherComponentStyles.css'
import SecondaryNav from '../../components/SecondaryNav'
import TeacherAbout from "./TeacherAbout";
import TeacherEducation from "./TeacherEducation";
import TeacherExperiences from "./TeacherExperiences";
import TeacherAchievements from "./TeacherAchievements";
import TeacherResearchProjects from "./TeacherResearchProjects";
import TeacherPublications from "./TeacherPublications";
import TeacherContacts from "./TeacherContacts";


const TeacherProfile = () => {
    const { id } = useParams();

    const location = useLocation();
    const navigate = useNavigate();
    let activeTab = location.hash.replace("#", "") || "bio";
    activeTab = activeTab.toLowerCase(); 
    const validTabs = ["bio", "research", "teaching", "contact"];
    if (!validTabs.includes(activeTab)) {
        activeTab = "bio";
    }    

    const [teacher, setTeacher] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const sub_menus = {
        "bio" : [
            {
                "slug": "about",
                "menu_text": "ABOUT"
            },
            {
                "slug": "education",
                "menu_text": "EDUCATION"
            },
            {
                "slug": "experiences",
                "menu_text": "EXPERIENCES"
            },
            {
                "slug": "achievements",
                "menu_text": "ACHIEVEMENTS"
            },
        ],

        "research": [
            {
                "slug": "researches",
                "menu_text": "RESEARCHES"
            },
            {
                "slug": "projects",
                "menu_text": "PROJECTS"
            },
            {
                "slug": "publications",
                "menu_text": "PUBLICATIONS"
            },           
        ],
        "teaching": [
            {
                "slug": "courses",
                "menu_text": "COURSES"
            },            
            {
                "slug": "materials",
                "menu_text": "MATERIALS"
            },  
            {
                "slug": "supervision",
                "menu_text": "SUPERVISION"
            },
        ],
        "contact": [
            {
                "slug": "contact",
                "menu_text": "CONTACT"
            },            
            {
                "slug": "offices",
                "menu_text": "OFFICES"
            },            
        ]
    }  

    const external_profile_icons = {
        "Scopus" : "/images/ext_icons/scopus.png",
        "Google Scholar" : "/images/ext_icons/google_scholar.jpg",
        "LinkedIn" : "/images/ext_icons/linkedin.png",
        "Research Gate" : "/images/ext_icons/researchgate.jpg",
    }

    const [activeSubMenus, setActiveSubMenus] = useState({
        bio: sub_menus["bio"].length > 0 ? sub_menus["bio"][0].slug : "",
        research: sub_menus["research"].length > 0 ? sub_menus["research"][0].slug : "",
        teaching: sub_menus["teaching"].length > 0 ? sub_menus["teaching"][0].slug : "",
        contact: sub_menus["contact"].length > 0 ? sub_menus["contact"][0].slug : ""
    });    
   
    const activeSubMenu = activeSubMenus[activeTab] || "";
    
    const setActiveSubMenu = (submenu) => {
        setActiveSubMenus(prev => ({
            ...prev,
            [activeTab]: submenu 
        }));
    };

    const activate_tab = (activate) => {
        return activate? "main-nav-button btn-animated-bg active" : "main-nav-button btn-animated-bg";
    } 
    
    useEffect(() => {
        const fetchTeacherProfile = async () => {
            try {
                const response = await fetch(`/data/teacher_profile.json`);
                if (!response.ok) throw new Error("Failed to fetch teacher data");
                const data = await response.json();
                setTeacher(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchTeacherProfile();
    }, [id]);    

    if (loading) {
        return (
            <div className="loading-container">
                <div className="logo-wrapper">
                    <img src="/images/NSTU_logo.png" alt="NSTU Logo" className="loading-logo" />
                    <div className="pulse-ring"></div>
                </div>
                <p className="loading-text">Loading Teacher Data...</p>
            </div>
        );
    }
    if (error) return <h2>Error: {error}</h2>;

    return (
        <div>            
            <div className="nw-section">
                <div className = "nw-section-inner nw-flex-h nw-flex-cl col-gap-xl" style={{minHeight: '100px'}}>
                    <div className="nw-unit-1-4 span-on-mobile" style={{minWidth:'275px'}}> 
                        <img className="header-logo" src="/images/NSTU_logo_full.png" alt="NSTU logo full (new)"></img>                       
                    </div>
                    <p className="breadcrumb">
                        <span>Home</span>
                        <span>&nbsp;/&nbsp;</span>
                        <span>Department of CSTE</span>
                        <span>&nbsp;/&nbsp;</span>
                        <span>Faculty members</span>
                        <span>&nbsp;/&nbsp;</span>
                        <span>{teacher.name}</span>
                    </p>
                </div>            
            </div>

            <div className="nw-section">
                <div className="nw-section-inner nw-flex-h nw-flex-tl flex-no-wrap flex-wrap-on-small-tablet col-gap-xl">
                    <div className="nw-unit-1-4 span-on-mobile nw-flex-v flex-no-shrink row-gap-lg" style={{minWidth:'200px'}} >
                        <img className="teacher-image" src={teacher.image} alt={teacher.name}/>
                        <div className="teacher-external-profiles ext_profiles-show-icons hide-on-mobile">
                            <p className="sub-menu-header">EXTERNAL PROFILES</p>
                            {teacher.external_profiles?.length? (<ul>
                            {teacher.external_profiles.map((c, i) => (
                                <li key={i}>
                                    <a href={c.link} target="blank" style={{display: 'flex', alignItems: 'center'}}>
                                        <img className="teacher-external-profile-icon-small" src={external_profile_icons[c.name]}></img>
                                        <span>{c.name}</span>
                                    </a>
                                </li>))}
                            </ul>)
                            : (<p>No external profiles</p>)
                        }                            
                        </div>
                        <div className="teacher-external-profiles-mobile hide-on-desktop hide-on-tablet">                            
                        {
                        teacher.external_profiles?.length? 
                        teacher.external_profiles.map((c, i) => 
                            <a className="teacher-external-profile-mobile-btn" alt={c.name} href={c.link}>
                                <img className="teacher-external-profile-icon" title={c.name} src={external_profile_icons[c.name]}></img>
                            </a>
                            ) : null                    
                        }                            
                        </div>
                    </div>
                    <div className="nw-flex-v span-on-mobile nw-unit-grow">
                        <div className="teacher-basic-info">
                            <p className="teacher-designation">{teacher.designation}</p>
                            <h2>{teacher.name}</h2>
                            <p className="teacher-short-bio">
                                {teacher.short_bio}                            
                            </p>
                            <div className="short-separator"></div>
                            <p className="teacher-primary-affiliation">
                                <a className="teacher-primary-affiliation_link" href={teacher.primary_affiliation_link}>
                                {teacher.primary_affiliation}                            
                                </a>
                            </p>
                        </div>
                        <div className="teacher-details">
                            <div className="main-nav-buttons">
                                <button onClick={() => navigate("#bio")}
                                    className={activate_tab(activeTab === "bio")}>
                                    <span>Biography</span>
                                </button>
                                <button onClick={() => navigate("#research")} 
                                    className={activate_tab(activeTab === "research")}>
                                    <span>Research</span>
                                </button>
                                <button onClick={() => navigate("#teaching")} 
                                    className={activate_tab(activeTab === "teaching")}>
                                    <span>Teaching</span>
                                </button>
                                <button onClick={() => navigate("#contact")} 
                                    className={activate_tab(activeTab === "contact")}>
                                    <span>Contact</span>
                                </button>                               
                            </div>

                            <div>
                                {activeTab === "bio" && 
                                <div style={{minHeight: '400px'}}>
                                   <SecondaryNav menus={sub_menus["bio"]} activeMenu={activeSubMenu} setActiveMenu={setActiveSubMenu} />                                   
                                    {activeSubMenu === "about" && <TeacherAbout teacher={teacher} />}
                                    {activeSubMenu === "education" && <TeacherEducation teacher={teacher}/>}
                                    {activeSubMenu === "experiences" && <TeacherExperiences teacher={teacher}/>}
                                    {activeSubMenu === "achievements" && <TeacherAchievements teacher={teacher}/>}
                                </div>}

                                {activeTab === "research" && 
                                <div style={{minHeight: '400px'}}>
                                   <SecondaryNav menus={sub_menus["research"]} activeMenu={activeSubMenu} setActiveMenu={setActiveSubMenu} />
                                    {activeSubMenu === "researches" && <TeacherResearchProjects teacher={teacher} type="research" />}
                                    {activeSubMenu === "projects" && <TeacherResearchProjects teacher={teacher} type="project" />}
                                    {activeSubMenu === "publications" && <TeacherPublications teacher={teacher}/>}
                                </div>}

                                {activeTab === "teaching" && 
                                <div style={{minHeight: '400px'}}>
                                   <SecondaryNav menus={sub_menus["teaching"]} activeMenu={activeSubMenu} setActiveMenu={setActiveSubMenu} />
                                    {activeSubMenu === "courses" && <h4>Courses</h4>}
                                    {activeSubMenu === "materials" && <h4>Course materials</h4>}
                                    {activeSubMenu === "supervision" && <h4>Supervision</h4>}
                                </div>}

                                {activeTab === "contact" && 
                                <div style={{minHeight: '400px'}}>
                                    <SecondaryNav menus={sub_menus["contact"]} activeMenu={activeSubMenu} setActiveMenu={setActiveSubMenu} />
                                    <TeacherContacts teacher={teacher} tab={activeSubMenu} />
                                </div>}
                            </div>
                            
                        </div>

                    </div>
                </div>
            </div>
           
        </div>        
    );
};

export default TeacherProfile;
